// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__10_xn","list":"styles_list__2SPD3"};